import { render, staticRenderFns } from "./inspectionStat_v2.vue?vue&type=template&id=2980a6aa&"
import script from "./inspectionStat_v2.vue?vue&type=script&lang=js&"
export * from "./inspectionStat_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inspectionStat_v2.vue"
export default component.exports